import { useMemo } from "react";
import { Alert, Stack, Text, Textarea, Title } from "@mantine/core";
import { legacyReviewCapacityErrors } from "../../../utils/legacyReviewCapacity";
import {
  LEGACY_NARRATIVES,
  type LegacyReviewForm,
} from "../../../utils/legacyReviewForm";

export default function LegacyNarrativeFields({
  form,
}: {
  form: LegacyReviewForm;
}) {
  const capacityErrors = useMemo(
    () => Object.values(legacyReviewCapacityErrors(form.values)),
    [form.values]
  );
  return (
    <Stack gap="md">
      <Title order={3}>Reviewed report text</Title>
      {capacityErrors.length > 0 && (
        <Alert
          color="red"
          title="Draft text exceeds review limits"
          role="alert"
        >
          <Stack gap="xs">
            <Text size="sm">
              Complete original text remains in source evidence. Review the
              oversized draft fields before saving; no source text has been
              removed.
            </Text>
            {capacityErrors.map((message) => (
              <Text size="sm" key={message}>
                {message}
              </Text>
            ))}
          </Stack>
        </Alert>
      )}
      {LEGACY_NARRATIVES.map(({ field, label }) => (
        <Textarea
          key={field}
          label={label}
          autosize
          minRows={3}
          maxRows={16}
          {...form.getInputProps(field)}
        />
      ))}
      {form.values.additionalSections.map((section, index) => (
        <Textarea
          key={`${section.kind}-${index}`}
          label={section.label}
          autosize
          minRows={3}
          maxRows={16}
          {...form.getInputProps(`additionalSections.${index}.text`)}
        />
      ))}
    </Stack>
  );
}
